import type { AddressAutocompleteResponse } from '@library/types/addressAutocomplete';
import { api } from '@bo-services/api';
import { defaultHeaders } from '@bo-constants/apiHeaders';

export interface AddressAutocompleteQueryParams {
  query: string;
  latitude?: number;
  longitude?: number;
}

export const addressAutocompleteApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAddressAutocomplete: build.query<
      AddressAutocompleteResponse,
      AddressAutocompleteQueryParams
    >({
      query: ({ query, latitude, longitude }) => ({
        url: 'v1/addresses/autocomplete',
        method: 'GET',
        params: {
          query,
          latitude,
          longitude
        },
        headers: defaultHeaders
      }),
      providesTags: ['AddressAutocomplete']
    })
  })
});

export const { useGetAddressAutocompleteQuery } = addressAutocompleteApi;
